export const valueToIndex = (value, options) => Math.min(Math.max(options.map(o => o.value).indexOf(value), 0), options.length - 1);
export const valueToPercent = (value, options) => {
  const index = valueToIndex(value, options);
  return index / (options.length - 1) * 100;
};
export const indexToPercent = (index, options) => {
  return Math.min(Math.max(index, 0), options.length - 1) / (options.length - 1) * 100;
};
const getOptionPercent = (index, options) => {
  let indexPercent = 100 / (options.length - 1) / (index === 0 || index === options.length - 1 ? 2 : 1);
  const indexAdditional = 100 / (options.length - 1) / 5;
  if (options.length > 2) {
    if (index === 0 || index === options.length - 1) indexPercent += indexAdditional;
    if (index === 1) indexPercent -= indexAdditional;
    if (index === options.length - 2) indexPercent -= indexAdditional;
  }
  return indexPercent;
};
export const percentToIndex = (percent, options) => {
  return options.reduce((acc, o, index) => {
    if (acc.index !== null) {
      return acc;
    }
    const optionPercent = getOptionPercent(index, options);
    if (acc.percent + optionPercent >= percent) {
      return {
        ...acc,
        index: index
      };
    }
    return {
      ...acc,
      percent: acc.percent + optionPercent
    };
  }, {
    index: null,
    percent: 0
  }).index ?? (percent <= 0 ? 0 : options.length - 1);
};
export const indexToOffset = (index, options, containerWidth) => {
  return containerWidth * (index / (options.length - 1));
};
export const offsetToIndex = (offset, options, containerWidth) => {
  const percent = Math.min(Math.max(offset, 0), containerWidth) / containerWidth * 100;
  return percentToIndex(percent, options);
};